<template>
  <div class="sm-report-revenue">
    <div class="sm-wrap lg">
      <breadcrumbs-block :crumbs="breadcrumbs" />
      <h3>Revenue details</h3>
      <div class="sm-report-revenue__top">
        <period-select
          :preselect="false"
          :startFrom="from"
          :startTo="to"
          @set-period="switchPeriod"
        />
      </div>
      <div class="sm-report-revenue__table">
        <div class="sm-mobile-table sm-report-revenue__table-mobile">
          <div class="sm-mobile-table-item header">
            <div class="sm-mobile-table-item-row">
              <div class="sm-mobile-table-item-row-th date">Date</div>
              <div class="sm-mobile-table-item-row-th name">Name</div>
              <div 
                v-if="viewPort != 'small'"
                class="sm-mobile-table-item-row-th descr"
              >Description</div>
              <div 
                v-if="viewPort != 'small'"
                class="sm-mobile-table-item-row-th amount sm-txt-right"
              >Amount</div>
              <div class="sm-mobile-table-item-row-th net-revenue sm-txt-right">Net revenue</div>
              <div class="sm-mobile-table-item-row-th control-arrow"></div>
            </div>
          </div>
          <div
            v-for="item in revenue"
            :key="item.account_id"
            class="sm-mobile-table-item"
            :class="{
              'open': item.isOpen
            }"
          >
            <div 
              class="sm-mobile-table-item-row"
              @click="toggleItem(item)"
            >
              <div class="sm-mobile-table-item-row-elem date">{{item.date | moment('MMM D, YYYY')}}</div>
              <div class="sm-mobile-table-item-row-elem name">
                <text-truncate :text="item.name" />
                <!-- <a
                  href="#"
                  class="sm-link"  
                  @click.prevent="$router.push(`customer/${item.account_id}`)"
                >
                  <text-truncate :text="item.name" />
                </a> -->
              </div>
              <div
                v-if="viewPort != 'small'" 
                class="sm-mobile-table-item-row-elem descr"
              >
                <text-truncate :text="item.description" />
              </div>
              <div 
                v-if="viewPort != 'small'" 
                class="sm-mobile-table-item-row-elem amount sm-txt-right"
              >{{formatPrice(item.amount)}}</div>
              <div class="sm-mobile-table-item-row-elem net-revenue sm-txt-right">{{formatPrice(item.net_revenue)}}</div>
              <div class="sm-mobile-table-item-row-elem control-arrow">
                <include-svg :name="'icon-arrow-b-big'" />
              </div>
            </div>
            <ul class="sm-mobile-table-item-dropdown">
              <li v-if="viewPort == 'small'">
                <span class="sm-txt-capitalize">Description</span>
                <span>{{item.description}}</span>
              </li>
              <li v-if="viewPort == 'small'">
                <span class="sm-txt-capitalize">Amount</span>
                <span>{{formatPrice(item.amount)}}</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Phone charge</span>
                <span>({{formatPrice(item.phone_charge)}})</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Phone usage charge</span>
                <span>({{formatPrice(item.phone_usage_charge)}})</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Shipment charge</span>
                <span>({{formatPrice(item.shipment_charge)}})</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">SMS charge</span>
                <span>({{formatPrice(item.sms_charge)}})</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Fee</span>
                <span>({{formatPrice(item.spheremail_amount)}})</span>
              </li>
              <li>
                <span class="sm-txt-capitalize">Gross revenue</span>
                <span>{{formatPrice(item.gross_revenue)}}</span>
              </li>
              <template v-if="item.items.length">
                <li>
                  <span>Items:</span>
                  <span></span>
                </li>
                <li
                  v-for="(el, index) in item.items"
                  :key="`${item.date}-${item.name}-item-${index}`"
                >
                  <span class="item">{{index + 1}}. {{el.description}}</span>
                  <span>{{`${formatPrice(el.amount)} / (${formatPrice(el.spheremail_amount)})`}}</span>
                </li>
              </template>
            </ul>
          </div>
          <div
            v-if="!revenue.length"
            class="sm-report-revenue__table-empty"
          >
            <p class="sm-txt-center">No Revenue details for selected period</p>
          </div>
        </div>
      </div>
    </div>

    <sm-spinner :show="showSpinner" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Spinner from '@/components/Spinner';
import PeriodSelect from '@/components/reports/PeriodSelect';
import { mapActions, mapGetters } from 'vuex';
import {FormatPrice} from '@/utils/general-data';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'report-revenue',
  components: {
    'breadcrumbs-block': Breadcrumbs,
    'sm-spinner': Spinner,
    'period-select': PeriodSelect
  },
  data() {
    return {
      breadcrumbs: [
        {
          link: 'reports',
          name: 'admin-reports',
          text: 'Reports'
        },
        {
          link: 'report-revenue',
          name: 'admin-report-revenue',
          text: 'Report revenue',
          current: true
        }
      ],
      from: null,
      to: null,
      revenue: [],
      allowedBreakpoints: [
        'small',
        'medium',
        'large'
      ],

      showSpinner: false
    }
  },
  computed: {
    ...mapGetters({
      isMobile: 'isMobile'
    })
  },
  created() {
    let query = this.$route.query;
    this.from = query.from;
    this.to = query.to;
  
    if (
        !this.from || 
        this.from.toLowerCase().includes('invalid') ||
        !this.to ||
        this.to.toLowerCase().includes('invalid')  
      ) {
      this.redirectToCharges();
      return;
    }

    this.getData();
  },
  mixins: [ViewPort],
  methods: {
    ...mapActions({
      getNetRevenue: 'reports/getNetRevenue'
    }),
    formatPrice: FormatPrice,
    prepateItems(arr) {
      return arr.map(item => {
        const temp = {...item};
        temp.isOpen = false;
        return temp;
      })
    },
    redirectToCharges() {
      this.$router.push('reports?tab=charge');
    },
    toggleItem(item) {
      item.isOpen = !item.isOpen;
    },
    getData() {
      this.showSpinner = true;

      this.getNetRevenue({
        from: this.from,
        to: this.to
      })
        .then(res => {
          this.revenue = res.map(item => {
            return {
              ...item,
              isOpen: false
            }
          });
          this.showSpinner = false;
        });
    },

    switchPeriod(from, to) {
      if (!from || (isNaN(from) && from.split('-').length != 3))
        from = new Date().setFullYear(new Date().getFullYear() - 10);

      if (!to || (isNaN(to) && from.split('-').length != 3))
        to = new Date();

      this.from = this.$moment(from).format('YYYY-MM-DD');
      this.to = this.$moment(to).format('YYYY-MM-DD');
      
      this.$router.push({
        query: {
          from: this.from,
          to: this.to
        }
      });

      this.getData();
    }
  }
}
</script>

<style lang="scss">
  @use '@/assets/scss/general/mixins.scss' as *;
  @use '@/assets/scss/framework/scss-variables.scss' as *;
  @use '@/assets/scss/pages/common/reports/_report-revenue.scss';
</style>